import toast from 'react-hot-toast';
import { t } from 'i18next';

export const toastError = () => {
  toast.error(t('Error while saving'));
};
